import { api } from './client';

export interface ShareClassDto {
  id: number;
  name: string;
  valuePerUnit: number;
  description: string;
  saftCode: string;
  saftDescription: string | null;
  account: number;
  isInUse: boolean;
  shareCount: number;
}

export interface ShareOperationDetailDto {
  id: number;
  itemType: number;
  classId: number;
  className: string;
  personId: number;
  personName: string;
  amount: number;
  quantity: number;
  isInternal: boolean;
  remarks: string | null;
}

export interface ShareOperationDto {
  id: number;
  registrationDate: string;
  documentDate: string;
  documentNumber: string;
  documentName: string;
  remarks: string | null;
  updateDate: string;
  details: ShareOperationDetailDto[];
}

export interface SaveShareOperationDetail {
  itemType: number;
  classId: number;
  personId: number;
  quantity: number;
  isInternal: boolean;
  remarks: string | null;
}

export interface ShareholderDto {
  personId: number;
  personName: string;
  personCode: string;
  classId: number;
  className: string;
  valuePerUnit: number;
  amount: number;
  valueTotal: number;
  acquisitionDate: string | null;
}

export interface ShareCardRowDto {
  date: string;
  documentNumber: string;
  className: string;
  itemType: number;
  amount: number;
  running: number;
}

export const sharesApi = {
  classes: () => api.get<ShareClassDto[]>('/shares/classes'),

  saveClass: (cmd: { id: number; name: string; valuePerUnit: number; saftCode: string; account: number; description: string; saftDescription: string | null }) =>
    api.post<number>('/shares/classes', cmd),

  deleteClass: (id: number) => api.delete<void>(`/shares/classes/${id}`),

  operations: (params: { from?: string; to?: string; classId?: number; personId?: number }) =>
    api.get<ShareOperationDto[]>('/shares/operations', params),

  saveOperation: (cmd: {
    id: number;
    registrationDate: string;
    documentDate: string;
    documentNumber: string;
    documentName: string;
    remarks: string | null;
    expectedUpdateDate?: string | null;
    details: SaveShareOperationDetail[];
  }) => api.post<number>('/shares/operations', cmd),

  deleteOperation: (id: number) => api.delete<void>(`/shares/operations/${id}`),

  shareholders: (asOf: string) =>
    api.get<ShareholderDto[]>('/shares/shareholders', { asOf }),

  card: (params: { classId: number; personId: number; from: string; to: string }) =>
    api.get<ShareCardRowDto[]>('/shares/card', params),
};
